import { Select } from '@mantine/core'
import type { TValuesCurrentBlocks, TValuesCurrentPoints } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { useMemo } from 'react'
import { SharedSettings } from 'settings/SharedSettings'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'

const updateMapVisuals = (value: string | null) => {
  if (value === null) return

  const newValueType = value as TValuesCurrentBlocks & TValuesCurrentPoints

  mapControlsStore.setState((s) => ({
    ...s,
    mapVisualValueGroup: {
      ...s.mapVisualValueGroup,
      [MAP_VISUAL?.IMAGE_OVERLAY]: {
        ...s.mapVisualValueGroup?.[MAP_VISUAL?.IMAGE_OVERLAY],
        ndvi: {
          ...(s.mapVisualValueGroup?.[MAP_VISUAL?.IMAGE_OVERLAY]?.ndvi ?? { mItem: 'M_Block' }),
          valueType: newValueType && newValueType,
        },
      },
    },
  }))
}

export const NDVIDropdown = () => {
  const value = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup?.[MAP_VISUAL?.IMAGE_OVERLAY]?.ndvi?.valueType,
  )

  const properties = fieldAssetStore.useSelector((s) => s.properties)

  const data = useMemo(() => {
    const returner: { group: string; items: { value: TValuesCurrentBlocks | ''; label: string }[] }[] = [
      {
        group: translate.phrases.banyanApp('Vegetation Index'),
        items: [
          {
            value: 'imageryOverlayNDVI_current',
            label: translate.phrases.banyanApp('Latest Vegetation Index'),
          },
          {
            value: 'imageryOverlayNDVIChange_sinceLastImage',
            label: translate.phrases.banyanApp('Short Term Change'),
          },
          {
            value: 'imageryOverlayNDVIChange_sinceLastMonth',
            label: translate.phrases.banyanApp('Long Term Change'),
          },
        ],
      },
      {
        group: translate.phrases.banyanApp('Visible Crop'),
        items: [
          {
            value: 'imageryOverlayRGB_current',
            label: translate.phrases.banyanApp('Latest Visible Crop'),
          },
        ],
      },
    ]

    return returner
  }, [properties, value])

  return (
    <Select
      data={data}
      value={value}
      onChange={updateMapVisuals}
      styles={SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER}
      comboboxProps={{ withinPortal: true }}
    />
  )
}
